import React, { useState, useEffect, useRef, useContext } from "react";
import MenuScreen from "./MenuScreen";
import LoaderScreen from "./LoaderScreen";
import CustomMarkupGrid from "./CustomMarkupGrid";
import RowList from "./RowList";
import ErrorScreen from "./ErrorScreen";
import errorIcon from "../assets/NoSearchResultFound1.png";
import ModalScreen from "./ModalScreen";
import { Translate } from "./LanguageChanger";
import loginimg from "../assets/loginimg.png";
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import logoutIcon from "../assets/Logout-Icon.png";
import { getHomeContent, getMasterHitV2, logoutUser } from "../services/services";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";
import { AppContext } from "../AppContext";
import HomeDetailsScreen from "../Module/VodDetails/VodDetailScreen";
import { fetchWithCache } from "../globalManager/CacheManager"; // Import Cache

const focusBorder = "2px solid #FF671F";

let fltrtgs = [];
let selectedTabId = -1;
let hometags = [];
let sentCategoryIds = new Set();

const CategoryScreen = ({ navigate, isLogedIn }) => {
  const isMountedRef = useRef(true); 
  const detailTimerRef = useRef(null); 

  const [state, setState] = useState({
    isLogedInUser: false,
    loading: true,
    category: null,
    categoryItems: [],
    filterTags: [],
    shouldFocusToRowList: true,
    shouldFocusToGrid: false,
    selectedRowIndex: 0,
    shouldCloseMenu: true,
    isError: false,
    shouldShowModal: false,
    errTitle: "",
    errDescription: "",
    errIcon: "",
    button: ["Logout", "Cancel"],
    iconWdth: "",
    iconHeight: "",
    rememberFocusItem: null,
    lastFocusedElementRowList: null,
  });

  const {
    loading,
    category,
    categoryItems,
    shouldFocusToRowList,
    shouldFocusToGrid,
    shouldCloseMenu,
    isError,
    shouldShowModal,
    errTitle,
    errDescription,
    errIcon,
    button,
    iconWdth,
    iconHeight,
    rememberFocusItem,
    lastFocusedElementRowList,
  } = state;

  const [screen, setScreen] = useState();
  const [data, setData] = useState({});
  const [rememberRowFocus, setRememberRowFocus] = useState(null);
  const [rememberColFocus, setRememberColFocus] = useState(null);
  const [selectedTag, setSelectedTag] = useState();
  
  const { sourceContext, setSourceContext } = useContext(AppContext);

  // --- STYLES (Standard Object) ---
  const styles = {
    categoryContainer: {
      background: `url(${solidbackgroundimg})`,
      display: "flex",
      flexDirection: "column",
      width: "100vw",
      height: "100vh",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      position: "absolute",
      overflow: "hidden",
    },
    header: {
      display: "column",
      width: "1890px",
      overflow: "hidden",
      marginLeft: "78px",
      alignItems: "center",
      textAlign: "center",
      fontSize: "40px",
      color: "#FFFFFF",
      background: "transparent",
      position: "absolute",
      paddingTop: "38px",
    },
    contentArea: {
      display: "flex",
      flexDirection: "column",
      height: "990px",
      width: "1880px",
      overflow: "hidden",
      marginLeft: "78px",
      marginTop: "120px",
      background: "transparent",
      position: "absolute",
    },
    rowListContainer: {
        position: "absolute",
        marginTop: "10px",
        width: "1802px",
        height: "75px",
        overflow: "hidden",
        marginLeft: "30px",
        backgroundImage: `url(${solidbackgroundimg})`,
    },
    gridContainer: {
        position: "absolute",
        width: "1802px",
        height: "940px",
        overflow: "hidden",
        marginLeft: "35px",
        marginTop: "105px",
    }
  };

  useEffect(() => {
    isMountedRef.current = true;
    
    setSourceContext("Categories/(1/Movies)");
    setSelectedTag({ id: 1, title: "Movies" });
    sendMatomoEvent({
      category: "Page",
      action: "View",
      name: "Categories",
      url: "categories",
    });

    loadData();

    return () => {
      isMountedRef.current = false;
      if (detailTimerRef.current) {
        clearTimeout(detailTimerRef.current);
      }
    };
  }, []);

  const navigateToScreen = (screen, data = {}) => {
    setScreen(screen);
    setData(data);
  };

  const sendMatomoEvent = (event) => {
    const { category, action, name, url } = event;
    sendTestMatomoEvent({
      eventCategory: category,
      eventAction: action,
      eventName: name,
      url: url || "",
    });
  };

  const loadData = async () => {
    const getCountry = localStorage.getItem("country");
    let headers = {
      iskid: "0",
      Langid: "1",
      "Content-Type": "application/json",
      country: getCountry,
    };

    try {
      // CACHE: Master Category List
      const fetchedCategory = await fetchWithCache(
        `MasterHitV2_${getCountry}`,
        () => getMasterHitV2(headers)
      );

      if (!isMountedRef.current) return;

      const validCategories = fetchedCategory?.data?.categories?.filter(
        (cat) => cat.disableTv === 1
      );

      if (!validCategories || validCategories.length === 0) {
          throw new Error("No categories found");
      }

      // CACHE: First Category Content
      const firstCatId = validCategories[0].id;
      const fetchedCategoryItem = await fetchWithCache(
        `CategoryContent_${firstCatId}`,
        () => getHomeContent(firstCatId)
      );

      if (!isMountedRef.current) return;

      fltrtgs = [];
      hometags = [];
      let rowCounter = 0;

      validCategories.forEach((category, i) => {
        if (i === 0) selectedTabId = category.id;
        category.setRowId = rowCounter++;
        fltrtgs.push(category);
        hometags.push(category.id);
      });

      setState((prevState) => ({
        ...prevState,
        loading: false,
        category: validCategories,
        categoryItems: fetchedCategoryItem.data,
        filterTags: fltrtgs,
      }));

    } catch (error) {
      console.error("Category Load Error:", error);
      if (isMountedRef.current) {
        setState((prevState) => ({
            ...prevState,
            loading: false,
            isError: true,
            shouldCloseMenu: false,
            shouldFocusToGrid: false,
        }));
        MenuScreen.SetFocus(false);
      }
    }
  };

  const fetchSelectedCatItem = async (SeletedItem) => {
    try {
      // CACHE: Specific Category Content
      const fetchedCategoryItem = await fetchWithCache(
        `CategoryContent_${SeletedItem.id}`,
        () => getHomeContent(SeletedItem.id)
      );

      if (isMountedRef.current) {
        setState((prevState) => ({
            ...prevState,
            loading: false,
            categoryItems: fetchedCategoryItem.data,
        }));
      }
    } catch (e) {
      if (isMountedRef.current) {
        setState((prevState) => ({
            ...prevState,
            loading: false,
        }));
      }
    }
  };

  const RowlListcallBack = (SeletedItem) => {
    setSourceContext(`Categories/(${SeletedItem.id}/${SeletedItem.title})`);
    setSelectedTag(SeletedItem);

    setState((prevState) => ({
      ...prevState,
      loading: true,
      categoryItems: [], 
      shouldFocusToRowList: true,
      shouldFocusToGrid: false,
      lastFocusedElementRowList: "RowList",
      rememberFocusItem: SeletedItem.setRowId,
    }));

    setRememberRowFocus(0);
    setRememberColFocus(0);
    
    fetchSelectedCatItem(SeletedItem);

    if (!sentCategoryIds.has(SeletedItem.id)) {
      // sendMatomoEvent({
      //   category: "Categories",
      //   action: "Select",
      //   name: `${SeletedItem?.id}/${SeletedItem?.title}`,
      // });
      sentCategoryIds.add(SeletedItem.id);
    }
  };

  const detailToDetail = (recommendationItem) => {
    if(detailTimerRef.current) clearTimeout(detailTimerRef.current);

    setState((prevState) => ({ ...prevState, loading: true }));
    navigateToScreen("", recommendationItem);
    
    detailTimerRef.current = setTimeout(function () {
      if (isMountedRef.current) {
        setState((prevState) => ({ ...prevState, loading: false }));
        navigateToScreen("HomeDetailsScreen", recommendationItem);
      }
    }, 100);
  };

  const handleMarkupGridOKButton = (selectedItem) => {
    let categoryValue = selectedItem.category;
    const categoryParts = categoryValue ? categoryValue.split(",") : ["", ""];
    const categoryId = categoryParts[0];
    const categoryName = categoryParts[1];

    const VOD = selectedItem?.type == 0;
    const AOD = selectedItem?.type === 1 || selectedItem?.media_type === 1;

    if (VOD || AOD) {
      navigateToScreen("HomeDetailsScreen", selectedItem);
      return;
    }

    // sendMatomoEvent({
    //   category: "CategoryPage",
    //   action: "ContentSelected",
    //   name: `${categoryId}/${categoryName}`,
    // });
  };

  const handleRightButton = () => {
    setState((prevState) => ({
      ...prevState,
      shouldFocusToRowList: true,
      shouldCloseMenu: true,
    }));
    MenuScreen.SetFocus(true);
  };

  const handleRowListDownButton = () => {
    setState((prevState) => ({
      ...prevState,
      shouldFocusToRowList: false,
      shouldFocusToGrid: true,
    }));
  };

  const handleRowListUpButton = () => {};

  const handleBackButton = () => {
    setState((prevState) => ({
      ...prevState,
      shouldFocusToRowList: false,
      shouldFocusToGrid: false,
      shouldCloseMenu: false,
    }));
    MenuScreen.SetFocus(false);
  };

  const handleMarkupGridUPButton = () => {
    setState((prevState) => ({
      ...prevState,
      shouldFocusToRowList: true,
      shouldFocusToGrid: false,
    }));
  };

  const handleMenuselection = (selectedMenu) => {
    const menuMap = {
      "Login": "LoginScreen",
      "Profile": "ProfileScreen",
      "Search": "SearchScreen",
      "Live": "LiveScreen",
      "LiveEvents": "LiveEventsScreen",
      "Home": "HomePage",
      "Categories": "CategoryScreen",
      "Settings": "SettingsScreen"
    };
    
    if(menuMap[selectedMenu]) {
        navigate(menuMap[selectedMenu]);
    }
  };

  const handleLogout = () => {
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
      shouldShowModal: true,
      shouldFocusToRowList: false,
      shouldFocusToGrid: false,
      errTitle: "Logout",
      errDescription: "cofirm-logout",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Logout", "Cancel"],
    }));
    MenuScreen.SetFocus(true);
  };

  const handleLogin = () => {
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
      shouldShowModal: true,
      shouldFocusToRowList: false,
      shouldFocusToGrid: false,
      errTitle: "Login to Continue",
      errDescription: "LoginContinue",
      errIcon: loginimg,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Login", "Cancel"],
    }));
    MenuScreen.SetFocus(true);
  };

  const handleExit = () => {
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
      shouldShowModal: true,
       shouldFocusToRowList: false,
      shouldFocusToGrid: false,
      errTitle: "Exit",
      errDescription: "ExitMsg",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Yes", "No"],
    }));
    MenuScreen.SetFocus(true);
  };

  const modalOKButtonHandler = (action) => {
    switch (action) {
      case "Login":
        navigate("LoginScreen");
        sendMatomoEvent({ category: "Page", action: "View", name: "LoginPopup" });
        break;
      case "Logout":
        logoutUser();
        localStorage.removeItem("JWTToken");
        localStorage.removeItem("userInfo");
        MenuScreen.ReseTfocus(4);
        MenuScreen.SetFocus(true);
        handleMenuselection("Login");
        break;
      case "Yes":
        if (window.tizen) {
          sendMatomoEvent({ category: `App`, action: "End" });
          window.tizen.application.getCurrentApplication().exit();
        } else {
          sendMatomoEvent({ category: `App`, action: "End" });
          window.close();
        }
        break;
      default: break;
    }
  };

  const modalCANCELButtonHandler = () => {
    MenuScreen.ReseTfocus(7);
    setState((prevState) => ({
      ...prevState,
      shouldShowModal: false,
      shouldFocusToRowList: true,
    }));
  };

  const handleBackFromDetail = () => {
    setState((prevState) => ({
      ...prevState,
      shouldFocusToGrid: true,
    }));
    setScreen("CategoryScreen", {});
  };

  const filteredCategories = Array.isArray(category) ? category.filter((item) => item?.disableTv === 1) : [];

  if (screen === "HomeDetailsScreen") {
    return (
      <HomeDetailsScreen
        handleBack={handleBackFromDetail}
        navigate={navigate}
        data={data}
        isLogedIn={isLogedIn}
        detailToDetail={detailToDetail}
        selectedTag={selectedTag}
      />
    );
  }

  return (
    <div style={styles.categoryContainer}>
      {loading && <LoaderScreen />}

      <div style={styles.header}>
        <Translate langKey={"category_name"} />
      </div>

      <div style={styles.contentArea}>
        <div
          style={styles.rowListContainer}
          onMouseEnter={() => setState((prevState) => ({
            ...prevState,
            shouldFocusToRowList: true,
            shouldFocusToGrid: false,
          }))}
        >
          <RowList
            borderRadius="10px"
            rowWidth="1802px"
            rowHeight="70px"
            columnWidth="273px"
            columnHeight="70px"
            itemWidth="273px"
            itemHeight="70px"
            animationSpeed={300}
            bgColor="transparent"
            shouldFocus={shouldFocusToRowList}
            shouldFocusToRowList={shouldFocusToRowList}
            borderBottom="5px solid #EC008C"
            marginLeft="0px"
            marginTop="0px"
            border={shouldFocusToRowList ? "2px solid #EC008C" : focusBorder}
            borderColor={shouldFocusToRowList ? "#EC008C" : "transparent"}
            fontSize="26px"
            fontColor="#FFFFFF"
            selectionStyle="background"
            gapBetweenColumn={15}
            data={filteredCategories}
            RowlListcallBack={RowlListcallBack}
            handleBackButton={handleBackButton}
            handleRowListDownButton={handleRowListDownButton}
            handleRowListUpButton={handleRowListUpButton}
            activeStyle={"underline"}
            lastFocusedElementRowList={lastFocusedElementRowList}
            rememberFocusItem={rememberFocusItem}
            screen={"CategoryScreen"}
          />
        </div>

        <div
          style={styles.gridContainer}
          onMouseEnter={() => setState((prevState) => ({
            ...prevState,
            shouldFocusToGrid: true,
            shouldFocusToRowList: false,
          }))}
        >
          <CustomMarkupGrid
            rowWidth={1802}
            rowHeight={358}
            gapBetweenRow={35}
            columnWidth={228}
            columnHeight={291}
            gapBetweenColumn={30}
            itemWidth={228}
            itemHeight={291}
            numRows={3}
            fontSize="32px"
            fontColor="#FFFFFF"
            selectionStyle="border"
            numColumns={7}
            shouldFocus={shouldFocusToGrid}
            data={categoryItems !== null ? categoryItems : []}
            marginLeft={0}
            marginTop={0}
            rowBgColor="#000000"
            isLogedIn={isLogedIn}
            columnBgColor={shouldFocusToGrid ? "#333333" : "transparent"}
            selectionColor={shouldFocusToGrid ? "#fff" : "transparent"}
            gapBetweenCatTitleAndItemList={15}
            verticalScrollStartIndex={0}
            horizontalScrollStartIndex={3}
            animationSpeed={60}
            handleBackButton={handleBackButton}
            handleMarkupGridUPButton={handleMarkupGridUPButton}
            handleMarkupGridOKButton={handleMarkupGridOKButton}
            rememberRowFocus={rememberRowFocus}
            setRememberRowFocus={setRememberRowFocus}
            rememberColFocus={rememberColFocus}
            setRememberColFocus={setRememberColFocus}
          />
        </div>
      </div>

      <MenuScreen
        navigate={navigateToScreen}
        handleMenuselection={handleMenuselection}
        shouldCloseMenu={shouldCloseMenu}
        handleRightButton={handleRightButton}
        isLogedIn={isLogedIn}
        appNavigate={navigate}
        handleLogin={handleLogin}
        handleLogout={handleLogout}
        handleExit={handleExit}
      />

      <ErrorScreen errorIcon={errorIcon} disply={isError ? "flex" : "none"} categories={true} />
      
      <ModalScreen
        shouldShowError={shouldShowModal}
        errTitle={errTitle}
        errDescription={errDescription}
        errIcon={errIcon}
        button={button}
        iconWdth={iconWdth}
        iconHeight={iconHeight}
        modalOKButtonHandler={modalOKButtonHandler}
        modalCANCELButtonHandler={modalCANCELButtonHandler}
      />
    </div>
  );
};

export default CategoryScreen;  